import { Edit as EditIcon } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';
import React from 'react';
import AdminLayoutView from 'src/Layout/AdminLayout/AdminLayoutView';
import AdminTabs from 'src/Layout/AdminLayout/AdminTabs';
import { AdminTabValue } from 'src/Layout/AdminLayout/AdminTabs/types';
import AdminViewWrapper from 'src/Layout/AdminLayout/AdminViewWrapper';
import GridData from 'src/components/GridData/GridData';
import { TableHeader, TABLE_HEADER_ACTION_SX } from 'src/components/TableHeader/TableHeader';
import { useAdminApplicationsViewController } from '../../controllers';
import { CreateAdminApplicationFormDrawer } from '../CreateAdminApplicationForm';

export const AdminApplicationsView = () => {
  const {
    isPageLoading,
    applicationsFilter,
    applicationList,
    changeApplicationsSearchFilter,
    changeApplicationsSorting,
    changeApplicationsPagination,
    createAdminApplicationFormDrawerController,
  } = useAdminApplicationsViewController();

  return (
    <>
      <CreateAdminApplicationFormDrawer {...createAdminApplicationFormDrawerController} />

      <AdminViewWrapper>
        <AdminLayoutView tabs={<AdminTabs value={AdminTabValue.applications} />}>
          <GridData
            header={
              <TableHeader
                searchValue={applicationsFilter.query}
                onSearchChange={changeApplicationsSearchFilter}
                actions={
                  <Button
                    onClick={() => createAdminApplicationFormDrawerController.open()}
                    variant="contained"
                    sx={TABLE_HEADER_ACTION_SX}
                  >
                    Create Application
                  </Button>
                }
              />
            }
            isLoading={isPageLoading}
            rows={applicationList?.items}
            columns={[
              {
                field: "name",
                headerName: "Application",
                minWidth: 200,
                editable: false,
                flex: 1,
              },
              {
                field: "domain",
                headerName: "Domain",
                minWidth: 200,
                editable: false,
                flex: 1,
              },
              {
                field: "priceForSMS",
                headerName: "SMS Credits",
                minWidth: 100,
                editable: false,
                flex: 1,
              },
              {
                field: "priceForMMS",
                headerName: "MMS Credits",
                minWidth: 100,
                editable: false,
                flex: 1,
              },
              {
                field: "priceForLookup",
                headerName: "Lookup Credits",
                minWidth: 100,
                editable: false,
                flex: 1,
              },
              {
                field: "priceForAlert",
                headerName: "Alert Credits",
                minWidth: 100,
                editable: false,
                flex: 1,
              },
            ]}
            renderAction={(r) => {
              return (
                <IconButton
                  size="small"
                  color="primary"
                  onClick={() => createAdminApplicationFormDrawerController.open(r)}
                >
                  <EditIcon fontSize="inherit" />
                </IconButton>
              );
            }}
            sorting={{
              value: applicationsFilter.sort,
              onChange: changeApplicationsSorting,
            }}
            pagination={{
              page: applicationsFilter.page,
              pageSize: applicationsFilter.limit,
              totalCount: applicationList?.count,
              onChange: changeApplicationsPagination,
            }}
          />
        </AdminLayoutView>
      </AdminViewWrapper>
    </>
  );
};
